export const emptyDoughnutPlugin = {
    id: 'emptyDoughnut',
    afterDraw(chart, args, options) {
        const hidden = Object.values(chart._hiddenIndices);
        const { labels } = chart.data;
        const { color, width, radiusDecrease, text } = options;
        
        let size = options.size || 20;

        let noData = labels.length == hidden.length &&  hidden.every((val) => val); 

        let sum = 0;
        let dataArr = chart.data.datasets[0].data.filter((item, index) => !chart._hiddenIndices[index]);
        dataArr.map(data => {
            sum += data;
        });

        noData = noData || sum == 0;

        if (noData) {
            const { chartArea: { left, top, right, bottom }, ctx } = chart;
            const centerX = (left + right) / 2;
            const centerY = (top + bottom) / 2;
            const r = Math.min(right - left, bottom - top) / 2;

            ctx.beginPath();
            ctx.lineWidth = width || 2;
            ctx.strokeStyle = color || 'rgba(255, 128, 0, 0.5)';
            ctx.arc(centerX, centerY, (r - radiusDecrease || 0), 0, 2 * Math.PI);
            ctx.stroke();

            ctx.fillStyle = color || 'rgba(255, 128, 0, 0.5)'; // Use the same color as the circle
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = `${size}px Roboto`; // Customize the font style and size
            ctx.fillText(text || 'No Available Options', centerX, centerY);
        }
    }
};